import { Typography } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { useInsuranceApi } from '../../../../../hooks/use-insurance-api';
import { UserError } from '../../../../../services/insurance/types/user-error';
import { CloseButton, DialogSubTitle, DialogToolbar } from '../../../../shared/dialog/dialog.styles';
import { withApptRequestIvStatusDialogProvider } from '../../hooks/use-appt-request-iv-status-dialog/hoc';
import { useApptRequestIvStatusDialog } from '../../hooks/use-appt-request-iv-status-dialog/hook';
import { ApptRequestIvStatusDialog } from '../appt-request-iv-status-dialog';
import { ManuallyVerifiedButton } from '../shared/manually-verified-button';
import { SelfPayButton } from '../shared/self-pay-button';
import { BoldText, InsuranceErrorList, InsuranceErrorListItem } from '../styles';

const RequestDataInvalidDialog: FC = () => {
  const [validationErrors, setValidationErrors] = useState<string[]>([]);
  const { status, getVerificationResponse } = useInsuranceApi();
  const { opened, onClose, isLoading, locationId, appointmentRequest, ivSummary } = useApptRequestIvStatusDialog();

  useEffect(() => {
    if (!opened || !ivSummary) return;

    (async () => {
      const verificationResponse = await getVerificationResponse(locationId, ivSummary.idVerificationRequest);

      if (verificationResponse && verificationResponse.rawResponse) {
        const userErrors: UserError[] = JSON.parse(verificationResponse.rawResponse);

        setValidationErrors(userErrors.map((e) => e.message));
      }
    })();
  }, [opened, ivSummary]);

  return (
    <ApptRequestIvStatusDialog
      opened={opened}
      title="Verification Request Data Invalid"
      subtitle={
        <BoldText>{`${appointmentRequest?.patient?.firstName} ${appointmentRequest?.patient?.lastName}`}</BoldText>
      }
    >
      <DialogSubTitle
        sx={{ margin: '10px 0 20px 0', display: 'block' }}
        isLoading={isLoading || status.getVerificationResponse.isRunning}
      >
        {validationErrors.length > 0 && (
          <>
            The insurance verification process encountered the following issues:
            <InsuranceErrorList>
              {validationErrors.map((error, index) => (
                <InsuranceErrorListItem key={index}>{error}</InsuranceErrorListItem>
              ))}
            </InsuranceErrorList>
            <Typography sx={{ marginBottom: '20px' }}>
              Once these issue are corrected you can try rerunning the insurance verification.
            </Typography>
          </>
        )}
        {validationErrors.length === 0 && (
          <>All invalid data issues have been corrected. Please try rerunning the verification again.</>
        )}
      </DialogSubTitle>

      <DialogToolbar>
        <ManuallyVerifiedButton onSuccess={async () => onClose()} disabled={isLoading} />
        <SelfPayButton onSuccess={async () => onClose()} disabled={isLoading} />
        <CloseButton onClick={onClose} disabled={isLoading} />
      </DialogToolbar>
    </ApptRequestIvStatusDialog>
  );
};

export default withApptRequestIvStatusDialogProvider(RequestDataInvalidDialog);
